var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7796 19.6652C16.3463 20.7141 14.5788 21.3333 12.6667 21.3333C7.8802 21.3333 4 17.4531 4 12.6667C4 7.8802 7.8802 4 12.6667 4C17.4531 4 21.3333 7.8802 21.3333 12.6667C21.3333 14.5788 20.7141 16.3463 19.6652 17.7796L27.6095 25.7239C28.1302 26.2446 28.1302 27.0888 27.6095 27.6095C27.0888 28.1302 26.2446 28.1302 25.7239 27.6095L17.7796 19.6652ZM18.6667 12.6667C18.6667 15.9804 15.9804 18.6667 12.6667 18.6667C9.35296 18.6667 6.66667 15.9804 6.66667 12.6667C6.66667 9.35296 9.35296 6.66667 12.6667 6.66667C15.9804 6.66667 18.6667 9.35296 18.6667 12.6667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a676c4f9537b8fd4e9136fafdde0dc5a.svg";
export { ForwardRef as ReactComponent };